export enum LineTypeEnum {
  straight,
  curve,
}
